import axios from "axios";
import {useMutation} from "react-query";

//${process.env.REACT_APP_API_URL}/admin/tenants/1630939384?branch=dev6
const deleteTenantImage = async ({identifier, branch}) => {
    const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/admin/tenants/${identifier}/documents?branch=${branch}`
    ).catch(err => console.log('useDeleteTenantImage::deleteTenantImage', err));
    return response?.data?.result;
}

export default function useDeleteTenantImage(){
    return useMutation(
        'DELETE_TENANT_IMAGE',
        (tenantConfig) => {
            return deleteTenantImage(tenantConfig)
        }
    );
}
